if (!customElements.get("product-pack-form")) {
  customElements.define(
    "product-pack-form",
    class ProductPackForm extends HTMLElement {
      get wrapper() {
        if (this._wrapper) return this._wrapper;
        this._wrapper = this.querySelector(".pack-wrapper");
        return this._wrapper;
      }
      _wrapper = null;
      get addToCartButton() {
        if (this._addToCartButton) return this._addToCartButton;
        this._addToCartButton = document.querySelector("#productMainSubmit");
        return this._addToCartButton;
      }
      _addToCartButton = null;
      get stickyAddToCart() {
        if (this._stickyAddToCart) return this._stickyAddToCart;
        this._stickyAddToCart = document.querySelector("#stickyAddtocartContainer button");
        return this._stickyAddToCart;
      }
      _stickyAddToCart = null;
      constructor() {
        super();
        this.packs = this.wrapper.querySelectorAll(".pack");
        this.currentPackQuantity = null;
        this.currentPackPrice = null;
        this.currentPackCompare = null;
        this.currentPackBadge = null;
        this.currentPackGuarantee = null;
        this.mediaGalleryBadge = document.querySelector(".card__badge.card__badge-dynamic img");
        this.inputQuantity = document.querySelector("input[name=quantity].quantity__input");
        this.guaranteeElements = document.querySelectorAll(".product-guarantee-text");
      }

      connectedCallback() {
        this.packs.forEach((pack) => {
          pack.addEventListener("click", () => {
            this.handlePackSelection(pack);
          });
        });
      }

      handlePackSelection(pack) {
        this.resetSelectedPack();
        pack.classList.add("pack-selected");
        this.currentPackQuantity = pack.dataset.quantity;
        this.currentPackPrice = pack.dataset.price;
        this.currentPackCompare = pack.dataset.compare;
        this.currentPackBadge = pack.dataset.badgeSrc;
        this.currentPackGuarantee = pack.dataset.guarantee;
        this.updateAddToCartButtons(this.addToCartButton);
        if (this.stickyAddToCart != null) this.updateAddToCartButtons(this.stickyAddToCart);
        this.updateInputQuantity(this.currentPackQuantity);
        if (this.mediaGalleryBadge != null) this.updateMediaGalleryBadge(this.mediaGalleryBadge);
        if (this.guaranteeElements.length > 0) this.updateGuaranteeText(this.guaranteeElements);
      }

      updateAddToCartButtons(button) {
        if (button.dataset.preorder === "true") {
          button.querySelector("div").innerText = window.variantStrings.preorderButton;
        } else {
          if (this.currentPackQuantity != 1) {
            button.innerHTML = `Ajouter au panier <span style="margin: 0 5px;">•</span>  ${(
              (this.currentPackQuantity * this.currentPackPrice) /
              100
            )
              .toFixed(2)
              .replace(".", ",")} € 
            <span style="text-decoration: line-through; margin: 0 5px;">${(this.currentPackCompare / 100).toFixed(2)} €</span>`;
          } else {
            button.innerHTML = `Ajouter au panier <span style="margin: 0 5px;">•</span>  ${(
              (this.currentPackQuantity * this.currentPackPrice) /
              100
            )
              .toFixed(2)
              .replace(".", ",")} €`;
          }
        }
      }

      updateInputQuantity(quantity) {
        document.querySelector("input[name=quantity].quantity__input").value = quantity;
      }

      updateMediaGalleryBadge(badgeElement) {
        badgeElement.src = this.currentPackBadge;
        badgeElement.style.display = "block";
      }

      updateGuaranteeText(guaranteeElements) {
        guaranteeElements.forEach((guaranteeElement) => {
          let defaultText = guaranteeElement.dataset.guaranteeText;
          guaranteeElement.innerHTML = defaultText.replace("||count||", this.currentPackGuarantee);
        });
      }

      resetSelectedPack() {
        this.packs.forEach((pack) => {
          pack.classList.remove("pack-selected");
        });
      }
    }
  );
}
